<template>
  <v-btn icon rounded small class="px-1" @click="refreshBalance">
    <v-icon>mdi-sync</v-icon>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  methods: {
      ...mapActions({
        updateUserAccountBalance: 'auth/updateUserAccountBalance',
      }),
    async refreshBalance() {
      const {data} = await axios.get('/api/user/get-balance')
      if (!isNaN(data)) this.updateUserAccountBalance(Number(data))
    }
  }
}
</script>
